import { AppState } from './store'
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UtforareFilterSlice {
  deviation: string[];
  flagLevel: number[];
  startDate: string | null
  endDate: string | null
}

// startDate/endDate = null → användaren har inte valt datum ännu → senaste körningens månad (#47).
// När ett datum väljs lagras det här och bibehålls vid navigering.
const initialState: UtforareFilterSlice = {
  deviation: [],
  flagLevel: [],
  startDate: null,
  endDate: null
};

const utforareFilterSlice = createSlice({
  name: 'utforareFilter',
  initialState,
  reducers: {
    setUtforareFilter(state, action: PayloadAction<Partial<UtforareFilterSlice>>) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const getUtforareFilter = (state: AppState) => state.utforareFilterReducer;
export const getDeviation = (state: AppState) => state.utforareFilterReducer.deviation;
export const getFlagLevel = (state: AppState) => state.utforareFilterReducer.flagLevel;
export const getUtforareStartDate = (state: AppState) => state.utforareFilterReducer.startDate
export const getUtforareEndDate = (state: AppState) => state.utforareFilterReducer.endDate
export const { setUtforareFilter } = utforareFilterSlice.actions;
export default utforareFilterSlice.reducer;

